export const conditionsConstants = {
    CONDITIONS_SELECTED: 'CONDITIONS_SELECTED'
  }